import React, { useState } from "react";
import "./style.scss";

const faqs = [
    {
        question: "What is Jamlyf?",
        answer:
            "Jamlyf is an inventory and ordering platform that allows customers" +
            "(“Ravers”) to scan a QR code at a spot, view the menu, and place orders digitally," +
            "while stewards and spot owners receive and manage orders in real time."
    },
    {
        question: "Who can use Jamlyf?",
        answer: 
            `
            - Spots (clubs, lounges, bars, event venues, restaurants)

            - Ravers (customers ordering from a spot)

            - Stewards (staff managing orders)
            `
    },
    {
        question: "Do ravers need to download an app?",
        answer:
            "No. Jamlyf works directly in the browser after scanning the QR code."
    },
    {
        question: "How does Jamlyf work for ravers?",
        answer:
            "Ravers simply scan a QR code at the spot, browse the menu, place an order, and wait for the steward to process it—no queues or shouting required."
    },
    {
        question: "How does Jamlyf work for spots?",
        answer:
            `
            Spots can:

                - Sign up and set up their venue

                - Upload and manage their menu

                - Generate a unique QR code

                - Receive and manage orders in real time
            `
    },
    {
        question: "Who are stewards?",
        answer: "Stewards are staff members of a spot to view, manage, and fulfill orders."
    },
    {
        question: "Does Jamlyf handle payments?",
        answer: "Payment features may be available depending on the spot’s setup. Jamlyf does not guarantee payment processing unless explicitly stated by the spot."
    },
    {
        question: "Is Jamlyf available for events and festivals?",
        answer: "Yes. Jamlyf can be used for one-time events, pop-ups, and festivals."
    },
    {
        question: "Is Jamlyf free to use?",
        answer: "Pricing and access may vary depending on the spot or event. Some features may be offered during promotional or trial periods."
    },
    {
        question: "Who do I contact for support?",
        answer:
            "You can reach us via the contact details provided on the Jamlyf website or through your spot managers."
    }
];

export default function FaqPage() {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggle = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    return (
        <div className="faq-page">
            <h1>Frequently Asked Questions</h1>

            {faqs.map((faq, index) => (
                <div
                    key={index}
                    className={`faq-item ${activeIndex === index ? "open" : ""}`}
                >
                    <button className="faq-question" onClick={() => toggle(index)}>
                        {faq.question}
                        <span>{activeIndex === index ? "−" : "+"}</span>
                    </button>

                    {activeIndex === index && (
                        <div className="faq-answer" style={{ whiteSpace: 'pre-line' }}>
                            <p>{faq.answer}</p>
                        </div>
                    )}
                </div>
            ))}
            <p className="meta">Version 1.0 · Last updated: Feb 2026</p>
        </div>
    );
}
